import React from "react";
import type { SpecsModel } from "../../specsModel/SpecsModel";
import { useSpecsModel, useSpecsModelSelector } from "../../SpecsModelContext";
import { SpecsAutocompleteField } from "../../SpecsEditorFields/index";

type SpecsModelAutocompleteFieldProps = Omit<
  React.ComponentProps<typeof SpecsAutocompleteField>,
  "value" | "onChange"
> & {
  selector: (model: SpecsModel) => string;
  setValue: (model: SpecsModel, nextValue: string) => void;
};

export default function SpecsModelAutocompleteField({
  selector,
  setValue,
  ...props
}: SpecsModelAutocompleteFieldProps) {
  const model = useSpecsModel();
  const value = useSpecsModelSelector(selector);

  const handleChange = React.useCallback(
    (nextValue: string) => {
      setValue(model, nextValue);
    },
    [model, setValue]
  );

  return (
    <SpecsAutocompleteField {...props} value={value} onChange={handleChange} />
  );
}
